import React from 'react'
import { Typography as MUITypography } from '@material-ui/core'

const Typography = ({ bold, style = {}, ...props }) => {
  const fontWeight = bold ? '600' : undefined
  return <MUITypography style={{ fontWeight, ...style }} {...props} />
}

export default Typography
